import { useEffect, useState } from 'react'
import * as yup from 'yup'
import { useFormik } from 'formik'
import LeftSidePopupLayout from '../../../../../component/popup/modal-layout'
import { useApiCall } from '../../../../../component/custom-hooks/api-call'
import { FeildError, FeildWraper, FormArea, FormLabel, SelectSearch } from '../../../../../component/form/form-layout'
import Style from './style.module.css'

const StockSupplyMoveItemPopup = ({ onClose = () => { }, onError = () => { }, onSubmit = () => { }, currentData, dropdowns }) => {
    const apiCall = useApiCall();
    const [QTY, setQTY] = useState(0);

    const validationSchema = yup.object().shape({
        to_location_id: yup.string().required('This Field is required'),
        quantity: yup
            .number()
            .typeError('Quantity must be a number')
            .required('This Field is required')
            .max(QTY, `Quantity cannot be greater than ${QTY}`)
            .min(1, 'Quantity must be greater than 0'),
    });


    useEffect(() => {
        if (currentData?.id) {
            formik.setFieldValue("to_location_id", currentData?.location_id)
            formik.setFieldValue("quantity", currentData?.quantity);
            setQTY(currentData?.quantity)
        }
    }, [currentData?.id])

    const formik = useFormik({
        initialValues: {
            to_location_id: "",
            quantity: "",
        },
        enableReinitialize: true,
        validationSchema,
        onSubmit: async (values) => {
            const enteredQty = Number(values.quantity);
            const maxQty = Number(QTY);

            if (enteredQty <= 0) {
                onError("Quantity must be greater than 0");
                return;
            }

            if (enteredQty > maxQty) {
                onError(`Quantity cannot be greater than ${maxQty}`);
                return;
            }

            const apiData = JSON.stringify({
                purchase_id: currentData?.id,
                to_location_id: values?.to_location_id,
                quantity: values?.quantity,
            });

            try {
                const resp = await apiCall({ method: "post", url: `move-item-location`, data: apiData });
                onSubmit(resp?.message || `Request Submitted`);
                formik.resetForm();
            } catch (error) {
                onError(error?.response.data?.respMsg || error?.response.data?.responseMessage || error?.response.data?.message || "Some Thing Went Wrong")
            }
        }
    });

    return (
        <>
            <div className={Style.modal_body}>
                <LeftSidePopupLayout popupStatus={true} className={`${Style.departmentChangeModal}`}>
                    <form onSubmit={formik.handleSubmit} className={Style.modal_main}>
                        <div className={Style.modal_body}>
                            <FormArea>
                                <FeildWraper width='100%'>
                                    <FormLabel required>Building</FormLabel>
                                    <SelectSearch
                                        isClearable={false}
                                        value={formik.values.to_location_id}
                                        onChange={(v) => formik.setFieldValue("to_location_id", v)}
                                        options={dropdowns?.buildings?.map(b => ({
                                            label: b.name,
                                            value: b.id,
                                        }))}
                                    />
                                    {formik.touched.to_location_id && formik.errors.to_location_id && (
                                        <FeildError>{formik.errors.to_location_id}</FeildError>
                                    )}
                                </FeildWraper>

                                <FeildWraper width='100%'>
                                    <FormLabel required>Quantity</FormLabel>
                                    <input
                                        type={'number'}
                                        name={'quantity'}
                                        onChange={formik.handleChange}
                                        value={formik.values.quantity}
                                        placeholder='Quantity'
                                        min={1}
                                        max={QTY}
                                        step="1"
                                    />
                                    {formik.touched.quantity && formik.errors.quantity && (
                                        <FeildError>{formik.errors.quantity}</FeildError>
                                    )}
                                </FeildWraper>
                            </FormArea>
                        </div>

                        <div className={Style.modal_foot}>
                            <button type='reset' className={`${Style.dcmb__cancel}`} onClick={onClose}>Discard</button>
                            <button type='submit' disabled={!formik.isValid || formik.isSubmitting} className={`${Style.dcmb__submit}`}>Apply</button>
                        </div>
                    </form>
                </LeftSidePopupLayout>
            </div>
        </>
    )
}

export default StockSupplyMoveItemPopup
